import { applicationConfig } from "@/constants/application-config.js";
import { getApiBaseUrl } from "@/helpers/api-base-url.js";
import { AppEventCounter } from "@/constants/app-event-counter-values";
import { endpoints } from "@/constants/endpoints";
import { headerKeys } from "@/constants/header-keys";

export class Telemetry {
    recordAppEventCounter({ event, label, status = "" }) {
        const body = {
            metric_name: AppEventCounter.MetricNames.DIGITAL_EVENT_V1,
            host: window.location.host,
            path: window.location.pathname,
            event,
            label,
            status,
        };

        const url =
            getApiBaseUrl(endpoints.RecordAppEventCounter.url) +
            endpoints.RecordAppEventCounter.url;

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                [headerKeys.APPLICATION_NAME]: applicationConfig.APPLICATION_NAME,
            },
            body: JSON.stringify(body),
            keepalive: true,
        }).catch((error) => {
            if (applicationConfig.CURRENT_ENVIRONMENT === "Localhost") {
                console.warn("recordAppEventCounter failed:", url, error);
            }
        });
    }
}

export default Telemetry;
